export default "__VITE_ASSET__93d608d4__$_?nuxt_component=async&nuxt_component_name=SvgoHelp2952989__"